import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../../../actions/modal';
import Table from '../../../common/Table';
import { Wrapper } from './styled';
import { fetchGetAdminWarehouse } from '../../../../actions/admin';

const operatorTypeToName = {
  MANUAL: `Свой склад`,
  FULFILLMENT: `Фулфилмент`,
};

const Leftovers = (props) => {
  const { values } = props;

  const dispatch = useDispatch();
  const rows =
    values?.warehouses?.map((item) => ({
      data: [
        {
          value: (
            <div className="title-wrapper">
              <h4 className="row-title">{item.title}</h4>
              {item.isDefault && <p className="row-comment">По умолчанию</p>}
              <i
                className="fe-edit-2"
                onClick={() =>
                  dispatch(showModal(`EditWarehouseSettings`, { title: `Сверка остатков`, item }))
                }
              />
            </div>
          ),
        },
        { value: operatorTypeToName[item.operatorType] },
        { value: <span className={`badge badge-success`}>Активен</span> },
      ],
    })) || [];

  useEffect(() => {
    dispatch(fetchGetAdminWarehouse());
  }, []);

  return (
    <>
      <div className="border-bottom">
        <h4 className="header-title">Сверка остатков</h4>
      </div>
      <Wrapper>
        <Table data={{ cols: [`Склад`, `Тип склада`, `Статус`], rows }} />
      </Wrapper>
    </>
  );
};

export default Leftovers;
